import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { del } from '../../helpers/api_helper';

export default function IntakeSummary() {
  const { t } = useTranslation();
  const [revision, setRevision] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');
  const deletingRef = useRef(false);
  useEffect(() => { document.title = t('Bin summary'); }, [t]);

  const deleteBin = async (row) => {
    if (deletingRef.current) return;
    // eslint-disable-next-line no-alert
    if (!window.confirm(t('Delete bin {{bin}} and all its items for everyone? This cannot be undone.', { bin: row.bin }))) return;
    deletingRef.current = true;
    setDeleting(true);
    setError('');
    try {
      await del('/api/sourcing/intake/bins', {
        data: { name: row.bin, generation: row.generation },
      });
      setRevision((value) => value + 1);
    } catch (deleteError) {
      setError(deleteError.response?.data?.error || deleteError.message || t('Unable to delete bin.'));
    } finally {
      deletingRef.current = false;
      setDeleting(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Can i="see" this="Sourcing">
          <Card>
            <CardHeader className="d-flex align-items-center justify-content-between gap-2">
              <h1 className="h4 mb-0">{t('Bin summary')}</h1>
              <div className="d-flex gap-2">
                <button className="btn btn-outline-primary" type="button" onClick={() => setRevision((value) => value + 1)}>
                  {t('Refresh')}
                </button>
                <Link className="btn btn-primary" to="/sourcing/intake">{t('Back to Sort')}</Link>
              </div>
            </CardHeader>
            <CardBody>
              <p className="text-muted">{t('All active shared bins, with the count of each scanned part. Empty bins show a count of zero.')}</p>
              {error && <div role="alert" className="alert alert-danger">{error}</div>}
              {deleting && <p role="status">{t('Deleting bin…')}</p>}
              <BaseGrid
                url="/api/sourcing/intake/summary"
                hasSearch
                shouldUpdate={revision}
                config={{
                  columns: {
                    bin: { label: 'Bin', sort: true, translate: false },
                    part_number: { label: 'Part number', sort: true, translate: false },
                    count: { label: 'Count', sort: true },
                    actions: {
                      label: 'Actions',
                      actions: [{
                        key: 'delete-bin',
                        icon: 'mdi mdi-trash-can-outline',
                        class: 'btn btn-sm btn-outline-danger',
                        alt: t('Delete bin and all its items'),
                        disabled: deleting,
                        click: deleteBin,
                      }],
                    },
                  },
                  pagination: { sort: 'bin', direction: 'asc', perPage: 30 },
                }}
              />
            </CardBody>
          </Card>
        </Can>
        <Can not i="see" this="Sourcing"><p>{t('Unauthorized')}</p></Can>
      </div>
    </div>
  );
}
